var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBriefcaseBlank = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C1.34315 6 0 7.34315 0 9V19.5C0 21.1569 1.34315 22.5 3 22.5H21C22.6569 22.5 24 21.1569 24 19.5V9C24 7.34315 22.6569 6 21 6H3ZM3 7.5C2.17157 7.5 1.5 8.17157 1.5 9V19.5C1.5 20.3284 2.17157 21 3 21H21C21.8284 21 22.5 20.3284 22.5 19.5V9C22.5 8.17157 21.8284 7.5 21 7.5H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3C18 2.17157 17.3284 1.5 16.5 1.5H7.5C6.67157 1.5 6 2.17157 6 3V6H7.5V3H16.5V6H18V3Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBriefcaseBlank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/briefcase-blank.bc2fccf1aedc8ab99557a7cf5eeb3868.svg";